import React from "react"
import {
  ReactUseState,
  IsSearchingContext,
  IsRestoreSearchingContext,
  GridInitializedContext,
} from "../../../components/Context"
import { T検索日種別コード } from "../../../constant/enum/frontend"
import {
  TZyutyuHaisyaListGetReq,
  TZyutyuHaisyaListGetRes,
} from "../../../service/order/zyutyuHaisya/TZyutyuHaisya"

export const SearchResultContext = React.createContext<
  TZyutyuHaisyaListGetRes[] | undefined
>([])

export const SearchMethodContext = React.createContext<
  (searchCondition?: TZyutyuHaisyaListGetReq<T検索日種別コード>) => unknown
>(() => {})

export const SearchConditionContext = React.createContext<
  TZyutyuHaisyaListGetReq<T検索日種別コード> | undefined
>({} as TZyutyuHaisyaListGetReq<T検索日種別コード>)

export const searchDyTypeContext = React.createContext<
  ReactUseState<"1" | "2" | null | undefined>
>({} as ReactUseState<"1" | "2" | null | undefined>)

export const searchDyFromContext = React.createContext<
  ReactUseState<string | null | undefined>
>({} as ReactUseState<string | null | undefined>)

export const searchDyToContext = React.createContext<
  ReactUseState<string | null | undefined>
>({} as ReactUseState<string | null | undefined>)

export const searchBusyoCdContext = React.createContext<
  ReactUseState<string | null>
>({} as ReactUseState<string | null>)

/**
 * 受注配車入力のProvider
 */
export const ZyutyuHaisyaTableProvider: React.FC<{
  isSearching: ReactUseState<boolean>
  isRestoreSearching: ReactUseState<boolean>
  gridInitialized: ReactUseState<boolean>
  SearchResult: Array<TZyutyuHaisyaListGetRes> | undefined
  searchCondition: TZyutyuHaisyaListGetReq<T検索日種別コード> | undefined
  search: (
    searchCondition?: TZyutyuHaisyaListGetReq<T検索日種別コード>
  ) => unknown
  isPrompt: React.MutableRefObject<boolean>
}> = (props) => {
  return (
    <IsSearchingContext.Provider value={props.isSearching}>
      <SearchResultContext.Provider value={props.SearchResult}>
        <GridInitializedContext.Provider value={props.gridInitialized}>
          <IsRestoreSearchingContext.Provider value={props.isRestoreSearching}>
            <SearchConditionContext.Provider value={props.searchCondition}>
              <SearchMethodContext.Provider value={props.search}>
                {props.children}
              </SearchMethodContext.Provider>
            </SearchConditionContext.Provider>
          </IsRestoreSearchingContext.Provider>
        </GridInitializedContext.Provider>
      </SearchResultContext.Provider>
    </IsSearchingContext.Provider>
  )
}
